import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useUser } from '@state/uses/users'
import { wideFormInput } from '@services/layout'
import TextInput from '@components/Form/TextInput'
import MessageModal from '@components/Modals/MessageModal'
import i18n from '@localization/i18n'
import { login } from '@state/actions/users'
import {
    PageHeader,
    TextBtn,
    SubmitBtn,
    SubmitBtnContainer,
    FormWrapper,
    FormRow,
    ErrorText,
} from '@appearance/styled'
import { reduce } from 'lodash'
import { useAppConfig } from '@state/uses/app'
import { getAppConfig } from '@state/actions/app'
import ActionButton from '@components/Dances/ActionButton'

export default () => {
    const errorTexts = {
        115: i18n.t('login.user_blocked'),
        105: i18n.t('login.no_existing_email'),
        106: i18n.t('login.wrong_password'),
        default: i18n.t('login.default_error'),
    }

    const user = useUser()
    const history = useHistory()
    const dispatch = useDispatch()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [emailValid, setEmailValid] = useState(null)
    const [passwordValid, setPasswordValid] = useState(null)
    const [error, setError] = useState(null)
    const [errorCode, setErrorCode] = useState('default')
    const [showErrorModal, setShowErrorModal] = useState(false)

    const tmpAppConfig = useAppConfig()
    const [appConfig, setAppConfig] = useState(tmpAppConfig)
    useEffect(() => {
        if (!tmpAppConfig) {
            dispatch(getAppConfig(setAppConfig))
        } else {
        }
    }, [tmpAppConfig])
    const reciepientsList = appConfig?.contact_us_list

    const goToMyDances = () => {
        history.push({
            pathname: '/dances',
            state: {
                searchByUser: {
                    id: user.user_id,
                    first_name: user.first_name,
                    last_name: user.last_name,
                },
            },
        })
    }
    const goToDances = () => {
        if (user?.is_admin) {
            history.push({
                pathname: '/dances',
                state: {
                    searchByOrderStratus: {
                        label: 'מוזמן',
                        value: 'מוזמן',
                    },
                },
            })
        } else {
            goToMyDances()
        }
    }

    useEffect(() => {
        setError(null)
        setErrorPerField(emailValid, 'דוא״ל לא תקין')
        setErrorPerField(passwordValid, 'סיסמה לא תקינה')
    }, [emailValid, passwordValid])

    useEffect(() => {
        if (user && user.user_id) {
            goToDances()
        }
    }, [user])

    const setErrorPerField = (field, error) => {
        if (field === false) {
            setError(error)
        }
    }

    const formValid = () => emailValid && passwordValid

    const onLoginError = (err) => {
        setShowErrorModal(true)
        console.log('onLoginError error ', err.data)
        const errCode =
            err?.data?.res_code ||
            err.data?.split(':')[1]?.split(',')[0] ||
            err.data?.data?.split(':')[1]?.split(',')[0]

        setErrorCode(errCode)
    }

    const doSubmit = () => {
        if (formValid()) {
            console.log('trying to log in')
            dispatch(login(email, password, onLoginError))
            console.log('sent login dispatch')
        }
    }

    const goToSignUp = () => {
        history.push('signup')
    }
    const goToForgotPassword = () => {
        history.push('forgot_password')
    }
    const contactUs = () => {
        window.location = 'mailto:' + reciepientsList
    }

    return (
        <WrapperDiv>
            <PageHeader>{i18n.t('login.log_in_if_registered')}</PageHeader>
            <SignUpBtnContainer>
                <ActionButton
                    label={i18n.t('login.not_signed_yet')}
                    onClick={goToSignUp}
                    bgColor={'#192F3A'}
                    smallText={i18n.t('login.signup_here')}
                />
            </SignUpBtnContainer>

            <FormWrapper>
                <FormRow>
                    <ErrorText
                        style={{
                            fontSize: '20px',
                            textShadow: '2px 2px gainsboro',
                            color: 'black',
                        }}>
                        {i18n.t('login.login_restricted_to_members')}
                    </ErrorText>
                </FormRow>
                <FormRow style={{ paddingTop: '10px' }}>
                    <ErrorText>{error}</ErrorText>
                </FormRow>
                <FormRow justifyContent={'center'} alignItems={'center'}>
                    <TextInput
                        text={email}
                        label={i18n.t('login.email')}
                        onChangeText={setEmail}
                        onDoneEdit={setEmailValid}
                        required={true}
                        width={wideFormInput}
                        onEnterPress={() => (formValid() ? doSubmit() : null)}
                        hideRequiredSign={true}
                    />
                </FormRow>
                <FormRow justifyContent={'center'} alignItems={'center'}>
                    <TextInput
                        text={password}
                        type="password"
                        label={i18n.t('login.password')}
                        onChangeText={setPassword}
                        onDoneEdit={setPasswordValid}
                        required={true}
                        width={wideFormInput}
                        hideRequiredSign={true}
                        onEnterPress={() => (formValid() ? doSubmit() : null)}
                    />
                </FormRow>
                <SubmitBtnContainer>
                    <SubmitBtn onClick={doSubmit} disabled={!formValid()}>
                        {i18n.t('login.log_in')}
                    </SubmitBtn>
                </SubmitBtnContainer>
                <TextBtn onClick={goToForgotPassword}>
                    {i18n.t('login.forgot_password')}
                </TextBtn>
                <TextBtn style={{ paddingTop: '15px' }} onClick={contactUs}>
                    {i18n.t('user_menu_headlines.contact_us')}
                </TextBtn>
            </FormWrapper>
            <MessageModal
                isOpen={showErrorModal}
                title={i18n.t('login.log_in_failed')}
                mainText={errorTexts[errorCode]}
                onClose={() => setShowErrorModal(false)}
                error
            />
        </WrapperDiv>
    )
}

const WrapperDiv = styled.div`
    width: 100%;
    text-align: center;
`
const SignUpBtnContainer = styled.div`
    margin-bottom: 20px;
    align-items: center;
    justify-content: center;
    display: flex;
`
